import Vue from 'vue'
import Router from 'vue-router'
const Layout = () =>
  import("@/views/layout/inner_layout");

Vue.use(Router)

export const constantRouterMap = [
  {
    path: "/login",
    component: () => import("@/views/login/login"),
    hidden: true,
  },
  {
    path: "/404",
    component: () => import("@/views/errorPage/404"),
    hidden: true,
  },
  {
    path: "/",
    component: Layout,
    redirect: "/xzqh",
    hidden: true,
  },
  {
    path: "/appsso",
    component: () => import("@/views/sso/sso"),
    hidden: true,
  },
  {
    path: "/xzqh",
    component: Layout,
    redirect: "/xzqh/index",
    meta: {
      title: "首页",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "xzqh",
        // component: () => import("@/views/index"),
        // name: "xzqh",
        // meta: {
        //   title: "首页",
        //   icon: "xzqh",
        // },
        redirect: "/xzqh/index"
      },
      {
        path: "index",
        component: () => import("@/views/index"),
        name: "index",
        meta: {
          title: "首页",
          icon: "index",
        },
      },
      {
        path: "xzqh-new",
        component: () => import("@/views/xzqh/xzqh"),
        name: "xzqh",
        meta: {
          title: "首页",
          icon: "xzqh",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/cwl",
    meta: {
      title: "财务类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "cwl",
        component: () => import("@/views/cwl/cwl"),
        name: "cwl",
        meta: {
          title: "财务类",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/jzjdinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "jzjdinfo",
        component: () => import("@/views/cwl/jzjdinfo"),
        name: "jzjdinfo",
        meta: {
          title: "结账进度",
          icon: "jzjdinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/szgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "szgkinfo",
        component: () => import("@/views/cwl/szgkinfo"),
        name: "szgkinfo",
        meta: {
          title: "收支公开",
          icon: "szgkinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/szgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "pzlookinfo",
        component: () => import("@/views/cwl/pzlookinfo"),
        name: "pzlookinfo",
        meta: {
          title: "凭证查看",
          icon: "pzlookinfo",
        },

        children: [],
      },
      {
        path: "pzinfo",
        component: () => import("@/views/cwl/pzinfo"),
        name: "pzinfo",
        meta: {
          title: "凭证详情",
          icon: "pzinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/cwbbinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "kmyebinfo",
        component: () => import("@/views/cwl/kmyebinfo"),
        name: "kmyebinfo",
        meta: {
          title: "科目余额表",
          icon: "kmyebinfo",
        },
      },
      {
        path: "szmxbinfo",
        component: () => import("@/views/cwl/szmxbinfo"),
        name: "szmxbinfo",
        meta: {
          title: "科目余额表",
          icon: "szmxbinfo",
        },
      },
      {
        path: "syfpbinfo",
        component: () => import("@/views/cwl/syfpbinfo"),
        name: "syfpbinfo",
        meta: {
          title: "收益及收益分配表",
          icon: "syfpbinfo",
        },
      },
      {
        path: "zcfzbinfo",
        component: () => import("@/views/cwl/zcfzbinfo"),
        name: "zcfzbinfo",
        meta: {
          title: "资产负债表",
          icon: "zcfzbinfo",
        },
      },
      {
        path: "zcfzbinfonew",
        component: () => import("@/views/cwl/zcfzbinfoNew"),
        name: "zcfzbinfonew",
        meta: {
          title: "资产负债表",
          icon: "zcfzbinfo",
        },
      },
      {
        path: "cwndjhbinfo",
        component: () => import("@/views/cwl/cwndjhbinfo"),
        name: "cwndjhbinfo",
        meta: {
          title: "财务计划表",
          icon: "zcfzbinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/cwbbinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "cwbbinfo",
        component: () => import("@/views/cwl/cwbbinfo"),
        name: "cwbbinfo",
        meta: {
          title: "财务报表",
          icon: "cwbbinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/nbwlgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "nbwlgkinfo",
        component: () => import("@/views/cwl/nbwlgkinfo"),
        name: "nbwlgkinfo",
        meta: {
          title: "内部往来公开榜",
          icon: "nbwlgkinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/xjyhzbgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "xjyhzbgkinfo",
        component: () => import("@/views/cwl/xjyhzbgkinfo"),
        name: "xjyhzbgkinfo",
        meta: {
          title: "现金银行逐笔公开榜",
          icon: "xjyhzbgkinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/yfkzbzxgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "yfkzbzxgkinfo",
        component: () => import("@/views/cwl/yfkzbzxgkinfo"),
        name: "yfkzbzxgkinfo",
        meta: {
          title: "应付款逐笔逐项公开榜",
          icon: "yfkzbzxgkinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/yszbzxgkinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "yszbzxgkinfo",
        component: () => import("@/views/cwl/yszbzxgkinfo"),
        name: "yszbzxgkinfo",
        meta: {
          title: "应收逐笔逐项公开榜",
          icon: "yszbzxgkinfo",
        },
      },
    ],
  },
  {
    path: "/cwl",
    component: Layout,
    redirect: "/cwl/yfflfinfo",
    meta: {
      title: "财务类",
      icon: "el-icon-star-off",
    },
    children: [
      {
        path: "yfflfinfo",
        component: () => import("@/views/cwl/yfflfinfo"),
        name: "yfflfinfo",
        meta: {
          title: "应付福利费逐笔逐项公开榜",
          icon: "yfflfinfo",
        },
      },
    ],
  },
  {
    path: "/zcl",
    component: Layout,
    redirect: "/zcl/zcl",
    meta: {
      title: "资产类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "zcl",
        component: () => import("@/views/zcl/zcl"),
        name: "zcl",
        meta: {
          title: "资产类",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/zcl",
    component: Layout,
    redirect: "/zcl/zcmxb",
    meta: {
      title: "资产类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "zcmxb",
        component: () => import("@/views/zcl/zcmxb"),
        name: "zcmxb",
        meta: {
          title: "资产明细表",
          icon: "",
          keepAlive: true,
        },
        children: [],
      },
      {
        path: "zcPicture",
        component: () => import("@/views/zcl/zcPicture"),
        name: "zcPicture",
        meta: {
          title: "资产图片",
          icon: "",
          keepAlive: true,
        },
      },
      {
        path: "zcdjb",
        component: () => import("@/views/zcl/zcdjb"),
        name: "zcdjb",
        meta: {
          title: "资源经营登记簿",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/htl",
    component: Layout,
    redirect: "/htl/htl",
    meta: {
      title: "合同类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "htl",
        component: () => import("@/views/htl/htl"),
        name: "htl",
        meta: {
          title: "合同类",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/htl",
    component: Layout,
    redirect: "/htl/zchtinfo",
    meta: {
      title: "合同类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "zchtinfo",
        component: () => import("@/views/htl/zchtinfo"),
        name: "zchtinfo",
        meta: {
          title: "查询对外投资合同",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/htl",
    component: Layout,
    redirect: "/htl/dwtzhtinfo",
    meta: {
      title: "合同类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "dwtzhtinfo",
        component: () => import("@/views/htl/dwtzhtinfo"),
        name: "dwtzhtinfo",
        meta: {
          title: "查询资产合同",
          icon: "",
          keepAlive: true,
        },
      },
      {
        path: "htFile",
        component: () => import("@/views/htl/htFile"),
        name: "htFile",
        meta: {
          title: "合同附件",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
  {
    path: "/htl",
    component: Layout,
    redirect: "/htl/gcjshtinfo",
    meta: {
      title: "合同类",
      icon: "el-icon-tickets",
    },
    children: [
      {
        path: "gcjshtinfo",
        component: () => import("@/views/htl/gcjshtinfo"),
        name: "gcjshtinfo",
        meta: {
          title: "查询工程建设合同",
          icon: "",
          keepAlive: true,
        },
      },
    ],
  },
];
export default new Router({
  scrollBehavior: () => ({
    y: 0
  }),
  routes: constantRouterMap
})
export let asyncRouterMap = [{
  path: '*',
  redirect: '/404',
  hidden: true
}]
